import { Component, Input } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'ns-header',
  template: require('./header.component.html'),
})
export class HeaderComponent {
  @Input() routeIsHome;
  @Input() isRobo;

  constructor(flowManager: FlowManagerService) {
    this.flowManager = flowManager;
  }

  goToDashboard() {
    this.flowManager.ssoToAlly();
  }

  logout(event) {
    this.flowManager.clearSessionAndLogout();
  }
}
